<template>
  <div class="option-item" @click="$emit('option-click')">
    <div class="option-item-icon">
      <slot name="option-item-icon"></slot>
    </div>
    <div class="option-item-text">
      <slot name="option-item-text"></slot>
    </div>
  </div>
</template>

<script>
const name = 'opti_select_item'

const props = {
  selected: {
    required: true
  },
  value: {
    required: true
  },
  blur: {
    type: Boolean,
    required: false,
    default: false
  }
}

export default {
  name,
  props
}
</script>

<style>
  .option-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    height: 36px;
    cursor: pointer;
    padding: 0 6px 0 10px;
    background-color: rgb(255, 255, 255);
    z-index: 210;
  }

  .option-item:hover {
    background-color: rgba(252, 252, 252, 1);
  }

  .option-item-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
  }

  .option-item-text span {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
            transform: translateY(-50%);
    font-weight: 400;
    font-size: 1.1em;
    letter-spacing: 0.05em;
  }

  .option-item-icon {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin: 0 10px 0 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/optimus/OptiSelectItem.vue